module.exports = __webpack_public_path__ + "img/cc-visa.f5dcfb25.svg";